import stormwaterAPI from "../../services/stormwaterAPI";

const appError = {
  applicationError: {
    hasError: true,
    error: [
      " We seem to be experiencing some technical difficulties. You can try reloading the page or try after sometime."
    ]
  }
};

export default {
  healthCheck: ({ commit }) => {
    try {
      stormwaterAPI
        .healthCheck()
        .then(response => {
          if (response && response.status === 200) {
            return;
          }
        })
        .catch(error => {
          if (error.response?.status === 503) {
            commit("setErrors", {
              maintenanceError: {
                hasError: true,
                error: error.response?.data?.response?.message || ""
              }
            });
          } else {
            commit("setErrors", appError);
          }
        });
    } catch (error) {
      commit("setErrors", appError);
    }
  },
  loadStreetNames: async ({ commit }, payload) => {
    try {
      await stormwaterAPI.getStreetName(payload).then(response => {
        if (response.status === 200) {
          commit("setStreetNameOptions", response.data);
        } else {
          commit("setErrors", appError);
        }
      });
    } catch (error) {
      console.log(error);
      commit("setErrors", appError);
    }
  },
  validateAddress: async ({ commit }, payload) => {
    const { StreetNameToken, StreetNumber } = payload;
    if (StreetNameToken && StreetNameToken.length && StreetNumber) {
      try {
        await stormwaterAPI.validateAddress(payload).then(response => {
          if (response && response.status === 200) {
            commit("setAddressDetails", response.data);
          } else {
            commit("setErrors", appError);
          }
        });
      } catch (error) {
        console.log(error);
        if (error.status === 400) {
          commit("setAddressDetails", { Success: false });
        } else commit("setErrors", appError);
      }
    }
  },
  fetchEstimate: ({ commit }, { payload, setLoading, nextStep }) => {
    try {
      stormwaterAPI
        .fetchEstimate(payload)
        .then(response => {
          if (response && response.status === 200 && response.data) {
            setLoading(false);
            commit("setEstimate", response.data);
            nextStep();
            commit("setErrors", {
              estimateDetailsError: {
                hasError: false,
                error: []
              }
            });
          } else {
            commit("setErrors", appError);
          }
        })
        .catch(err => {
          if (
            err &&
            err.response &&
            err.response.status === 400 &&
            err.response.data &&
            err.response.data.errors
          ) {
            let formattedErrors = [];
            (Object.values(err.response.data.errors) || []).map(error => {
              if (Array.isArray(error)) {
                formattedErrors.push(...error);
              } else {
                formattedErrors.push(error);
              }
            });
            commit("setErrors", {
              estimateDetailsError: {
                hasError: true,
                error: formattedErrors
              }
            });
          } else {
            commit("setErrors", appError);
          }
        });
    } catch (error) {
      console.log(error);
    }
  },
  setValue: ({ commit }, value) => {
    commit("setValue", value);
  },
  setErrors: ({ commit }, error) => {
    commit("setErrors", error);
  }
};
